<template>
  <div class="Login">
    <div class="px-logo">
      <a href="https://www.cin.ufpe.br" target="_blank">
        <img src="../assets/logo-horizontal.png" alt="Logo do CIn (Centro de Informática)" id="first-logo">
      </a>
    </div>
    <br>
     <div>
      <h4 style="color: black" class="title">Recupera&ccedil;&atilde;o de senha da rede</h4> 
      <div class="barra"></div>
      <br>
      <div class="authBlock">
        <div class="formGroup">
          <div class="row">
            <div class="col text-center">
              <button class="btn googleBtn text-left" @click="login" style="font-size: 15px; width: 100%; height: 55px;">
                <img src="../assets/new-google-favicon-512.png" class="googleIcon"/>                
                <span class="googleText"> Entre com o Google </span>
              </button>
            </div>
          </div>
          <div class="text-center" style="vertical-align: middle;">
            <div class="bar"></div><h5 style="display: inline-block; padding: 0 6px 0 6px; width: 38%;">dom&iacute;nio cin.ufpe.br</h5><div class="bar"></div>
          </div>
        </div>
        <br>
      </div>
      <ol class="pacotes">
        <li class="pacote">
          <img src="../assets/logo-vertical.png" alt="Logo do CIn (Centro de Informática)">
        </li>
        <li class="pacote" style="margin-top: auto; margin-bottom: auto;">
          <small>
            <h6>
              © Centro de Inform&aacute;tica UFPE - Todos os direitos reservados
            </h6>
          </small>
        
          <small>
            <h6> Tel +55 81 2126.8430 - Cidade Universit&aacute;ria - 50740-560 - Recife/PE</h6>
          </small>
        </li>
        <li class="pacote">
            <img src="../assets/marca_UFPE_producao2_RGB-02.png" alt="Logo da UFPE (Universidade Federal de Pernambuco)" class="ufpe">
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  name: 'login',
  data(){
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login: function(){
      const provider = new firebase.auth.GoogleAuthProvider().setCustomParameters({
        hd: "cin.ufpe.br"
      });
      firebase.auth().signInWithPopup(provider)
      .then((result) => {
        if (result.user.email.split('@')[1] != 'cin.ufpe.br') { 
          
          firebase.auth().signOut().then(() => {
            sessionStorage.removeItem('user'); 
            alert("Você deve utilizar um e-mail com domínio cin.ufpe.br ")
          })
        
        } else {
            /*axios({
              method: 'post',
              url: process.env.VUE_APP_API_URL + "/checkUser", 
              data: {
                usuario: result.user.email
              }
            })
            .then((result) => {
              console.log("Nada")
            })
            .catch((error) => {
              console.log(error.response.data.errors[0])
            })*/

          this.setUserData(result.user);
          this.setUserToken(result)
          this.$router.replace('dashboard');
        }

      })
      .catch((err) => {
        switch(err.code) {
          case 'auth/popup-closed-by-user':
            break;
          case 'auth/account-exists-with-different-credential':
            break;
          case 'auth/auth-domain-config-required':
            break;
          case 'auth/cancelled-popup-request':
            break;
          case 'auth/operation-not-allowed':
            alert("Desculpe, infelizmente sua conta não tem acesso, por favor fale com o suporte");
            break;
          case 'auth/operation-not-supported-in-this-environment':
            break;
          case 'auth/popup-blocked':
            alert("O Pop-up de login foi bloqueado pelo navegador");
            break;
          case 'auth/unauthorized-domain':
            break;
        }

      })
    },
    setUserData: function(user){
      const userData = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
        emailVerified: user.emailVerified
      }
      sessionStorage.setItem('user', JSON.stringify(userData));
    },
    setUserToken(result){
      result.user.getIdToken(false).then(value => {
        sessionStorage.setItem('token', JSON.stringify(value));
      });
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
div{
  h4 {
    text-align: center;
    width: 100%;
    color: gray;
    font-size: 49px;
    margin: 0 0 20px;
    font-weight: lighter;
    word-wrap: break-word;
    text-overflow: clip;
    font-family: 'Oswald', sans-serif;
  }
}

.googleIcon {
  height: 23px; 
  width: 23px; 
  margin-right: 50px; 
  vertical-align: middle; 
}

@media screen and (max-width: 376px) {
  .googleIcon {
    height: 23px; 
    width: 23px; 
    margin-right: 15%; 
    vertical-align: middle; 
  } 
}

@media screen and (max-width: 325px) {
  .googleIcon {
    height: 23px; 
    width: 23px; 
    margin-right: 7%; 
    vertical-align: middle; 
  } 

  .title {
    font-size: 25px;
  }

  #first-logo{
    display: none;
  }

  .pacote {
    flex: 1 1 230px;
    list-style: none;
    padding: 0px;
    text-align: center;
    padding-top: 0;
  }  

}



.googleText {
  vertical-align: middle; 
  font-weight: normal;
}

.formGroup {
  margin-bottom: 20px;
  float: left;
  width: 100%;
  .googleBtn {
    color: black;
    border-color: lightgrey;
    border-width: 3px;
    border-top-width: 1px;
    border-left-width: 1px;
    font-weight: 700;
    background: white;
    //padding: 15px 40px;
    // margin-left: 25px;
    margin-bottom: 5px;
    i {
      width: 22px;
      text-align: center;
      margin-right: 5px;
    }
  }
  .btn:hover {
    background: #f7f7f7;
  }
  h5 {
    text-align: center;
    color: #D50022;
    font-size: 12px;
    font-weight: bold;
    margin: 0 0 2px;
  }
}

.bar {
  width: 30%;
  height: 2px;
  display: inline-block;
  background-color: #D50022;
  vertical-align: middle;
}

small {
  h6 {
    text-align: center;
    color: black;
    font-size: 12px;
    margin: 0 0 2px;
    font-weight: lighter;
    word-wrap: break-word;
    text-overflow: clip;
    font-family: 'Oswald', sans-serif;
  }
}

body {
  margin: 0;
  padding: 0;
  font-weight: 400;
  width: 100%;
  height: 100%;
  font-family: 'Poppins', sans-serif;
}

.barra{
  width: 75%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 12px;
  background-color: #D50022;
}

.authBlock {
  margin: 0 auto;
  max-width: 400px;
  padding: 30px 40px 10px;
  overflow: hidden;
  // -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .04);
  // box-shadow: 0 0 4px 0 rgba(0, 0, 0, .04);
}

.pacotes {
  width: 100%;
  height: 10%;
  display: flex;
  flex-wrap: wrap;
  padding-top: 5%;
  padding-bottom: auto;
  padding-left: 0;
  .pacote {
    flex: 1 1 230px;
    list-style: none;
    padding: 0 5% 10px;
    text-align: center;
    padding-top: 10%;
    .ufpe {
      margin-top: -30px;
    }
    img {
      max-height: 130px;
      max-width: 200px;
      width: auto;
      height: auto;
    }
  }
}

.px-logo {
  display: block;
  clear: both;
  margin: 4% auto 20px;
  width: 220px;
  a {
    img {
      width: 100%;
    }
  }
}

.Login {
  margin: auto;
  
}
</style>
